// extracted by mini-css-extract-plugin
export default {"colorPickerOverlay":"EditTextScene__colorPickerOverlay___E4WVC"};